/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-magic-numbers */
import axios from 'axios'

const Server = {
    async get(path: string) {
        try {
            const response = await axios.get(`${process.env.API_URL}${path}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-api-key': process.env.API_KEY,
                },
            })

            const json = await response.data

            if (response.status === 200) {
                return { success: true, data: json }
            }

            return { success: false, message: json.message }
        } catch (error: any) {
            return { success: false, message: error.message }
        }
    },
}

export { Server }
